// ============================================================================
// Advanced manufacturing — consistent API scope for work item queries & creates
// Ensures lists and creates stay isolated from service-operations and other
// module_context values. Use with POST /api/v1/work-items action: "list" etc.
// ============================================================================

export const ADVANCED_MANUFACTURING_MODULE_CONTEXT = 'advanced-manufacturing' as const;

export const MANUFACTURING_JOB_SUBTYPE_PRODUCTION_ORDER = 'production_order' as const;
export const MANUFACTURING_JOB_SUBTYPE_MANUFACTURING_STAGE = 'manufacturing_stage' as const;
export const MANUFACTURING_JOB_SUBTYPE_OUTSOURCED_OPERATION = 'outsourced_operation' as const;

/** Optional fields forwarded to POST action:list → GET work-items (pagination, search, aggregates). */
export type AdvancedManufacturingListBodyPartial = Record<string, unknown> & {
  item_type?: string | string[];
  item_subtype?: string | string[];
  limit?: number;
  page?: number;
  /** Server-side search (title, etc. — see work-items API). */
  search?: string;
  status?: string | string[];
  include_total?: boolean;
  include_status_counts?: boolean;
  counts_only?: boolean;
  sort_by?: string;
  sort_order?: string;
};

/** POST body for action: list — always scoped to advanced-manufacturing */
export function advancedManufacturingListBody(
  partial: AdvancedManufacturingListBodyPartial,
): Record<string, unknown> {
  return {
    action: 'list',
    module_context: ADVANCED_MANUFACTURING_MODULE_CONTEXT,
    ...partial,
  };
}

/** Parent work orders in dropdowns: production_order jobs only, manufacturing context */
export function advancedManufacturingParentJobListBody(limit = 200): Record<string, unknown> {
  return advancedManufacturingListBody({
    item_type: 'job',
    item_subtype: MANUFACTURING_JOB_SUBTYPE_PRODUCTION_ORDER,
    limit,
  });
}

/** Fields to merge into work item create payloads for shop-floor / manufacturing rows */
export function advancedManufacturingCreateFields(): {
  module_context: typeof ADVANCED_MANUFACTURING_MODULE_CONTEXT;
} {
  return { module_context: ADVANCED_MANUFACTURING_MODULE_CONTEXT };
}
